module.exports = __webpack_public_path__ + "img/ComputerOutlined.3bd8c676.svg";